/** Unique projects for the weekly bar chart legend (stack order, first seen). */
export const collectWeeklyChartLegendProjects = (barData) => {
  const seen = new Set();
  const legend = [];

  (barData ?? []).forEach((day) => {
    (day.projects ?? []).forEach((project) => {
      if (!project?.name || !(project.hours > 0) || seen.has(project.name)) {
        return;
      }
      seen.add(project.name);
      legend.push({
        name: project.name,
        projectId: project.projectId,
        colorIndex: project.colorIndex,
      });
    });
  });

  return legend;
};
